/* eslint-disable max-classes-per-file */
import { Directive, inject, Injectable } from '@angular/core';
import {
  MatLegacyPaginator as MatPaginator,
  MatLegacyPaginatorIntl as MatPaginatorIntl,
} from '@angular/material/legacy-paginator';

// based on
// https://github.com/angular/components/blob/15.2.9/src/components-examples/material/paginator/paginator-intl/paginator-intl-example.ts
// and
// https://v15.material.angular.dev/components/paginator/examples
@Injectable()
export class MyCustomPaginatorIntl extends MatPaginatorIntl {
  override getRangeLabel = (pageIndex: number, pageSize: number, length: number) => {
    if (length === 0) {
      return `Page 1 of 1`;
    }
    const amountPages = Math.ceil(length / pageSize);
    return `Page ${pageIndex + 1} of ${amountPages}`;
  };
}

// hides the page size, and doesn't include the page size in the range label
@Directive({
  selector: 'mat-paginator[apIgnorePageSize]',
  providers: [
    {
      provide: MatPaginatorIntl,
      useClass: MyCustomPaginatorIntl,
    }
  ],
  standalone: true,
})
export class IgnorePageSizeDirective {
  private paginator = inject(MatPaginator);

  constructor() {
    this.paginator.hidePageSize = true;
    this.paginator.pageSize = 1;
  }
}



